// extracted by mini-css-extract-plugin
export default {"prevent_tiny_table":"AnimalsInField_prevent_tiny_table__+YlNi"};